import Gpt from '@op/components/GPT';
import useCustomDefaultPrompt from '@op/pages/AIAnalysisHub/CustomAISummary/hooks/useCustomDefaultPrompt';
import { useSaveCustomSummaryReport } from '@op/pages/AIAnalysisHub/CustomAISummary/hooks';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import CardCommon from '@op/components/CardCommon';
import { useHistory } from 'umi';
export function useFeedsGpt({
  filter,
  commonParams,
  gameInfo,
  specialParams,
  match_model,
  hasAdvancedSummary = true,
  wholeGameInfo,
  gptName,
  contentCard = false,
  feedsStats,
}: {
  filter: any;
  commonParams: any;
  gameInfo: any;
  specialParams?: any;
  match_model?: any;
  hasAdvancedSummary?: boolean;
  wholeGameInfo: any;
  gptName: string;
  contentCard?: boolean;
  feedsStats: { [key: string]: number };
}) {
  const toggleVisibleRef = useRef<any>(null);
  const handleStopRef = useRef<any>(null);
  const [showAigcCard, setShowAigcCard] = useState(false);
  const [gptSuccess, setGptSuccess] = useState(false);
  const { GPT_Btn } = useGetSingePageSourceRule({ keys: 'GPT_Btn' });
  const [filterParams, setFilterParams] = useState();
  const { promptList: keyOpinionsPromptList } = useCustomDefaultPrompt({
    gameInfo: wholeGameInfo,
  });

  const history = useHistory();

  const {
    saveVisible,
    saveUserSummary,
    saveTipsElement,
    saveTipsIcon,
    cardSaveIcon,
    toggleSaveWindow,
    saveParams,
    setIsSave
  } = useSaveCustomSummaryReport({
    gameInfo,
    changeTab: () => history.push(`/opinion/AIAnalysisHub/CustomAISummary?tab=summary&listTab=oneTime`)
  });

  useEffect(() => {
    handleStopRef.current?.();

    const params = [filter, commonParams, gameInfo, specialParams, match_model]
      .filter(Boolean)
      .reduce((pre, cur) => {
        if (typeof cur === 'string') {
          return { ...pre, match_model: cur };
        }

        return { ...pre, ...cur };
      }, {});

    setFilterParams(params);
  }, [filter, commonParams, gameInfo, match_model]);

  const GptElement = useMemo(() => {
    return (
      <CardCommon
        className="dbo-aigc-card-wrapper"
        style={{ display: showAigcCard ? 'block' : 'none' }}
        contentCard={contentCard}
      >
        <Gpt.PageCard
          filter={filterParams}
          hasStopBtn={true}
          autoRequest={false}
          contentCard
          linkFilterChange={false}
          oriFeedsState={feedsStats}
          className={'gpt-summary'}
          loadingHeight={160}
          saveName={'Feeds_' + gptName}
          refreshIsOpenWindows
          hasAdvancedSummary={hasAdvancedSummary}
          promptList={keyOpinionsPromptList}
          stopAction={() => setShowAigcCard(false)}
          successAction={() => setGptSuccess(true)}
          promptConfirm={(data) => {
            if (data.resultType === 'page') {
              setGptSuccess(false);
              setShowAigcCard(true);
              setIsSave(true);
            }
          }}
          loadingElement={saveTipsElement}
          saveClick={toggleSaveWindow}
          saveIcon={cardSaveIcon}
          wholeGameInfo={wholeGameInfo}
          showStatsHeader
        >
          {(
            toggleVisible: (value: boolean) => any,
            { total, handleStop }: any,
          ) => {
            toggleVisibleRef.current = toggleVisible;
            handleStopRef.current = handleStop;
            return (
              <div className="dbo-feeds-gpt-summary-btn">
                <Gpt.Button
                  disabled={total <= 0}
                  onClick={() => toggleVisible?.(true)}
                ></Gpt.Button>
              </div>
            );
          }}
        </Gpt.PageCard>
      </CardCommon>
    );
  }, [filterParams, showAigcCard, feedsStats, saveTipsElement, cardSaveIcon, toggleSaveWindow]);

  const GptBtnElement = useMemo(() => {
    if (GPT_Btn) return null;
    return (
      <div className="dbo-feeds-gpt-summary-btn">
        <Gpt.Button
          disabled={
            (feedsStats?.total <= 0 && toggleVisibleRef.current) ||
            (showAigcCard && !gptSuccess)
          }
          onClick={() => {
            toggleVisibleRef.current?.(true);
          }}
        ></Gpt.Button>
      </div>
    );
  }, [GPT_Btn, feedsStats, showAigcCard, gptSuccess]);

  return {
    GptElement,
    GptBtnElement,
    saveVisible,
    saveUserSummary,
    toggleSaveWindow,
    saveParams,
    saveTipsIcon,
  };
}
